import React from 'react';
import { spring, StaggeredMotion } from 'react-motion';
import styled from 'styled-components';
import { RichUtils } from 'draft-js';
import { theme } from '../../../styles/theme';

const EditorFeatures = styled.div`
  width: 100%;
  position: absolute;
  top: -32px;
  z-index: 1;
`;

const ControlButton = styled.button`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  border-radius: 2px;
  font: inherit;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  box-shadow: 0 2px 6px 0 rgba(0, 45, 234, 0.1);
  background: ${theme.colors.mainBlue};
  cursor: pointer;
  color: #ffffff;
  transition: transform 500ms ease-out;
  user-select: none !important;
  &:focus {
    outline: none;
  }

  &.feature-button-active {
    transform: scale(1.2) rotate(360deg);
  }
`;

export default function EditorMotion(props: any) {
  const onControlButtonClick = (event: any, buttonType: string) => {
    event.preventDefault();
    props.setEditorFocused(true);
    const newEditorState = RichUtils.toggleInlineStyle(
      props.editorState,
      buttonType,
    );
    props.setEditorState(newEditorState);
    props.setEditorStylesActive(
      newEditorState.getCurrentInlineStyle().size > 0,
    );
    const button = event.currentTarget;
    const btnIsActive = !props.editorState
      .getCurrentInlineStyle()
      .has(buttonType);
    button.classList.toggle('feature-button-active', btnIsActive);
    props.setCurrentMotionKey(buttonType.toLocaleLowerCase());
  };

  const featureButtons = [
    {
      fn: (event: any) => onControlButtonClick(event, 'BOLD'),
      type: 'BOLD',
      label: 'B',
    },
    {
      fn: (event: any) => onControlButtonClick(event, 'ITALIC'),
      type: 'ITALIC',
      label: 'I',
    },
    {
      fn: (event: any) => onControlButtonClick(event, 'UNDERLINE'),
      type: 'UNDERLINE',
      label: 'U',
    },
  ];

  const determineTag = (label: string) => {
    switch (label) {
      case 'B':
        return <span>{label}</span>;
      case 'I':
        return <i>{label}</i>;
      case 'U':
        return <u>{label}</u>;
      default:
        return <span />;
    }
  };
  return (
    <EditorFeatures className="editor-features">
      <StaggeredMotion
        defaultStyles={[{ o: 0 }, { o: 0 }, { o: 0 }]}
        styles={(prevInterpolatedStyles: any) =>
          prevInterpolatedStyles.map((_: any, i: any) => {
            return i === 0
              ? {
                  o: spring(1, {
                    stiffness: 60,
                    damping: 10,
                    precision: 0.001,
                  }),
                }
              : {
                  o: spring(prevInterpolatedStyles[i - 1].o, {
                    stiffness: 60,
                    damping: 10,
                    precision: 0.001,
                  }),
                };
          })
        }
      >
        {(interpolatingStyles: any) => (
          <div>
            {interpolatingStyles.map((style: any, i: any) => {
              const buttonClass = props.editorState
                .getCurrentInlineStyle()
                .has(featureButtons[i].type)
                ? 'feature-button feature-button-active'
                : 'feature-button';

              return (
                <ControlButton
                  key={i}
                  style={{ opacity: style.o }}
                  onMouseDown={featureButtons[i].fn}
                  className={buttonClass}
                >
                  {determineTag(featureButtons[i].label)}
                </ControlButton>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </EditorFeatures>
  );
}
